const en: typeof import("./fr").default = {
  // Nav
  nav_home: "Home",
  nav_about: "About",
  nav_services: "Services",
  nav_projects: "Projects",
  nav_contact: "Contact",
  nav_cta: "Request a quote",

  // Home hero
  hero_subtitle: "Quality In Every Build",
  hero_description: "Construction · Public Works · Transport & Logistics · Digital Solutions & AI · Health & Safety",
  hero_cta: "Discover our services",

  // Home services
  home_services_label: "Our fields",
  home_services_title: "Five areas of expertise",
  home_learn_more: "Learn more",

  // Home service cards
  svc_construction_title: "Construction",
  svc_construction_desc: "Buildings, bridges, metal structures and civil engineering works.",
  svc_tp_title: "Public Works",
  svc_tp_desc: "Roads, water networks, sanitation and public space development.",
  svc_logistique_title: "Transport & Logistics",
  svc_logistique_desc: "Equipment rental, material transport and supply chain management.",
  svc_sst_title: "Health & Safety",
  svc_sst_desc: "Safety audits, protective equipment and occupational health training.",
  svc_digital_title: "Digital Solutions & AI",
  svc_digital_desc: "Software development, data analytics, machine learning, BI and enterprise digital transformation.",

  // Home figures
  fig_trades: "Specialized trades",
  fig_congolese: "Congolese capital",
  fig_sectors: "Business sectors",
  fig_projects: "Completed projects",

  // About
  about_title: "Building the future of Congo, one project at a time",
  about_subtitle: "RACHEVANE SARL - RAVA Brand",
  about_p1: "RACHEVANE SARL, operating under the RAVA brand, is a Congolese limited liability company headquartered at No. 08, Savonnier Avenue, Bel-Air district, Kampemba commune, city of Lubumbashi, Haut-Katanga province, Democratic Republic of Congo.",
  about_p2: "Entirely Congolese-owned, RAVA SARL has established itself as a key player in the construction, public works and engineering sectors in the DRC. The company carries an ambitious vision: contributing to the sustainable development of Congolese infrastructure through operational excellence and innovation.",
  about_p3: "RAVA SARL has expanded its expertise by integrating a dedicated digital solutions and artificial intelligence division. In collaboration with experts from McGill University and Omics Data Solutions Inc., the company supports its clients in their digital transformation, from custom software development to machine learning model implementation, including the deployment of data analytics platforms.",
  about_p4: "This dual expertise in traditional engineering and technological innovation positions RAVA SARL as a unique strategic partner, capable of addressing the most complex challenges of Congolese development.",
  about_p5: "RAVA SARL is governed by the provisions of the OHADA Uniform Act on commercial companies and economic interest groups, as well as all legal and regulatory provisions in force in the Democratic Republic of Congo.",
  about_legal: "Legal information",
  about_values_label: "Our principles",
  about_values_title: "Six founding values",
  val_quality: "Quality",
  val_quality_desc: "Every structure is delivered with impeccable execution, with no compromise on materials or finishes.",
  val_safety: "Safety",
  val_safety_desc: "The protection of our teams and partners is an absolute priority on every job site.",
  val_innovation: "Innovation",
  val_innovation_desc: "We integrate the most advanced methods and technologies to meet the challenges of each project.",
  val_deadlines: "Meeting deadlines",
  val_deadlines_desc: "Our schedule commitments are met. A project delivered on time is a mark of trust and professionalism.",
  val_environment: "Environment",
  val_environment_desc: "Responsible practices are integrated into each of our field interventions.",
  val_satisfaction: "Client satisfaction",
  val_satisfaction_desc: "We work until we achieve a result that fully meets our clients' expectations.",
  about_partners_label: "Partners",
  about_partners_title: "Our strategic partners",
  about_partners_text: "RAVA collaborates with leading institutions and companies to ensure the excellence of its services.",

  // Services listing
  services_title: "Our services",
  services_description: "Five areas of expertise to meet all your construction, infrastructure and technology needs.",

  // Service detail
  svc_detail_highlights: "What we offer",
  svc_detail_process: "Our process",
  svc_detail_cta_title: "Need this service?",
  svc_detail_cta_text: "Contact us for a free quote. Response within 24 hours.",
  svc_detail_cta_button: "Request a quote",
  svc_detail_others: "Other services",

  // Realisations
  real_title: "Projects",
  real_description: "A selection of projects that demonstrate our expertise and technical rigor.",
  real_filter_all: "All",

  // Contact
  contact_title: "Contact",
  contact_description: "Let's start your project together. Free quote within 24 hours.",
  contact_info_label: "Details",
  contact_form_title: "Quote request",
  contact_form_subtitle: "Response within 24 business hours.",
  contact_name: "Full name",
  contact_email: "Email",
  contact_phone: "Phone",
  contact_budget: "Estimated budget",
  contact_budget_select: "Select",
  contact_budget_10: "Less than $10,000",
  contact_budget_50: "$10,000 - $50,000",
  contact_budget_200: "$50,000 - $200,000",
  contact_budget_plus: "More than $200,000",
  contact_service: "Service type",
  contact_service_select: "Select a service",
  contact_message: "Project description",
  contact_message_placeholder: "Describe your project...",
  contact_submit: "Send request",
  contact_sending: "Sending...",
  contact_success_title: "Message sent",
  contact_success_text: "We will get back to you as soon as possible.",
  contact_success_again: "Send another message",
  contact_error: "An error occurred. Please try again.",
  contact_whatsapp: "Message on WhatsApp",
  contact_required: "*",

  // Footer
  footer_tagline: "Quality In Every Build",
  footer_location: "Lubumbashi, Haut-Katanga, DRC",
  footer_nav: "Navigation",
  footer_services: "Services",
  footer_contact: "Contact",
  footer_rights: "RAVA. All rights reserved.",

  // 404
  notfound_title: "Page not found",
  notfound_back: "Back to home",
};

export default en;
